<template>
  <div class="lead-form-modal">
    <div class="lead-form-modal__underlay"></div>
    <form class="lead-form-modal__form text-left bg-white shadow-md rounded px-8 pt-6 pb-8 my-4" @submit.prevent="submitForm">
      <div class="mb-6">
        <div class="text-black">Thank you for visiting Al&nbsp;Mouj,&nbsp;Muscat.<br>Please complete your details below to review your favourites.</div>
      </div>
      <div class="mb-6">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="first_name">First Name *</label>
        <input class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" id="first_name" name="first_name" required v-model="user.first_name">
      </div>
      <div class="mb-6">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="last_name">Last Name *</label>
        <input class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" id="last_name" name="last_name" required v-model="user.last_name">
      </div>
      <div class="mb-6">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="email">Email *</label>
        <input class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="email" id="email" required v-model="user.email">
      </div>
      <div class="mb-2">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="phone">Phone Number (inc. country code) *</label>
        <input class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="tel" id="phone" required v-model="user.phone">
      </div>
      <div class="mb-6">
        <p class="opacity-75 text-xs">* required</p>
      </div>
      <div class="mb-2">
        <label class="block text-gray-700 font-bold flex">
          <input class="mr-2 leading-tight" type="checkbox" v-model="user.existing_client">
          <span class="text-sm">
            I am an existing client
          </span>
        </label>
      </div>
      <div class="mb-2">
        <label class="block text-gray-700 font-bold flex">
          <input class="mr-2 leading-tight" type="checkbox" v-model="user.opt_in">
          <span class="text-sm">
            I want to receive further information via email
          </span>
        </label>
      </div>
      <div class="mb-6">
        <label class="block text-gray-700 font-bold flex">
          <input class="mr-2 leading-tight" type="checkbox" required>
          <span class="text-sm">
            I have read and understood the <a class="underline" href="https://www.almouj.com/en/privacy-policy" target="_blank">privacy policy</a> *
          </span>
        </label>
      </div>
      <div class="text-left">
        <button :disabled="isSubmitting || isSubmitted" class="button" type="submit">{{ isSubmitted ? 'Thank you' : isSubmitting ? 'Submitting...' : 'Submit' }}</button>
      </div>
    </form>
    <!-- <div class="lightbox__close" @click="$emit('close')"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></div> -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      isSubmitted: false,
      isSubmitting: false,
      user: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        existing_client: false,
        opt_in: '',
        favourites: this.$store.getters.favouritePropertyIds,
        propertyIds: this.$store.getters.favouritePropertyIds,
        propertyLabels: this.$store.getters.favouriteProperties.map(property => property.label)
      }
    }
  },

  mounted () {
    document.body.style.overflow = 'hidden';
  },

  methods: {
    submitForm () {
      this.isSubmitting = true
      axios.post(this.$store.state.API_HOST + 'favourites/lead', this.user)
        .then(() => {
        }).finally(() => {
          this.isSubmitting = false
          this.isSubmitted = true
          setTimeout(() => {
            this.$emit('submitted')
            document.body.style.overflow = 'initial';
          }, 1000)
        })
    }
  }
}
</script>

<style lang="scss">
.lead-form-modal {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  &__close {
    background-color: rgba(#333, 0.8);
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;
    
    svg {
      height: 40px;
      width: 40px;
    }
  }

  &__underlay {
    background: rgba(0, 0, 0, .8);
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  &__form {
    position: relative;
  }
}
</style>